import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Journey from '../components/Journey';
import Clients from '../components/Clients';
import Showcase from '../components/Showcase';
import Verticals from '../components/Verticals';
import CtaBanner from '../components/CtaBanner';
import WhyUs from '../components/WhyUs';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

export default function HomePage() {
  return (
    <main className="relative overflow-hidden bg-[#f4efe6]">
      <Header />
      <Hero />
      <Services />
      <Journey />
      <Clients />
      <Showcase />
      <Verticals />
      <CtaBanner />
      <WhyUs />
      <Contact />
      <Footer />
    </main>
  );
}
